import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SETTING_KEYS } from '@constants/settings';
import { ErrorsHandlerService } from '@services/errors-handler.service';
import { PermissionsService } from '@services/permissions.service';
import { getStorage } from '@utils/helper';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {
  constructor(private permissionService: PermissionsService, private errorHandlerService: ErrorsHandlerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if(request.url.includes('bot')) return throwError(() => errors);
        let errorMsg = 'Có lỗi xẩy ra, liên hệ với admin để biết thêm chi tiết!';
        if (error.status === 401) {
          errorMsg = getStorage(SETTING_KEYS.jwt) ? 'Hết phiên đăng nhập, vui lòng đăng nhập lại!' : 'Bạn phải đăng nhập để tiếp tục';
          localStorage.clear();
          location.reload();
        }
        if (error.status === 400) {
          errorMsg = error.error?.message || 'Xin hãy nhập đầy đủ form.';
        }
        const errors = new Error(errorMsg, {
          cause: error,
        });
        this.errorHandlerService.error(errors);
        return throwError(() => errors);
      })
    );
  }
}

export const errorInterceptor = { provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true };
